import { Link } from "@tanstack/solid-router";
import { For, Show } from "solid-js";

import { useAccountContacts } from "~/lib/hooks";

type Props = {
  wsKey: () => string;
  accountId: () => string;
};

export function AccountContactsCard(props: Props) {
  const links = useAccountContacts(props.wsKey, props.accountId);

  return (
    <div class="card bg-base-100 shadow-sm">
      <div class="card-body">
        <h3 class="card-title text-lg">People</h3>

        <Show when={links.isLoading}>
          <div role="status" class="py-4 text-center opacity-60 text-sm">
            Loading…
          </div>
        </Show>
        <Show when={links.isError}>
          <div role="alert" class="alert alert-error text-sm">
            Failed to load contacts.
          </div>
        </Show>

        <Show when={links.data}>
          {(data) => (
            <Show
              when={data().items.length > 0}
              fallback={
                <div class="text-center py-6 opacity-60 text-sm">
                  No contacts linked. Add them from a Contact's detail page.
                </div>
              }
            >
              <ul class="divide-y divide-base-300 mt-2">
                <For each={data().items}>
                  {(link) => {
                    const role = (link.attributes?.["role"] as string | undefined) ?? null;
                    return (
                      <li class="py-2">
                        <Link
                          to="/workspaces/$wsKey/contacts/$conId"
                          params={{ wsKey: props.wsKey(), conId: link.contact_id }}
                          class="link link-primary font-medium"
                        >
                          {link.contact_full_name || "Unnamed"}
                        </Link>
                        <Show when={link.is_primary}>
                          <span class="badge badge-primary badge-xs ml-2 align-middle">
                            primary
                          </span>
                        </Show>
                        <div class="text-xs opacity-60 truncate">
                          {[link.contact_title, role, link.contact_primary_email]
                            .filter(Boolean)
                            .join(" · ") || "—"}
                        </div>
                      </li>
                    );
                  }}
                </For>
              </ul>
            </Show>
          )}
        </Show>
      </div>
    </div>
  );
}
